export const WorkStatuses = {
  pending: { id: 1, name: 'Pending' },
  inReview: { id: 2, name: 'In review' },
  submitted: { id: 3, name: 'Submitted' },
  rejected: { id: 4, name: 'Rejected' },
  accepted: { id: 5, name: 'Accepted' },
  registering: { id: 6, name: 'Registering on societies' },
  updating: { id: 7, name: 'Updating on societies' },
  registered: { id: 8, name: 'Registered' },
  terminated: { id: 9, name: 'Terminated' },
}

export enum WriterRolesText {
  'Composer (Music only)' = 1,
  'Author (Lyrics only)',
  'Composer Author (Music & Lyrics)',
  'Arranger',
}

export const WriterRoles: {[key: number]: string} = {
  1: 'Composer (Music only)',
  2: 'Author (Lyrics only)',
  3: 'Composer Author (Music & Lyrics)',
  4: 'Arranger',
}

export const WriterRolesDropdownOptions = Object.entries(WriterRoles)
  .map<DropdownOption>(([id, name]) => ({ id: Number(id), name }))

export enum WriterStatuses {
  requested = 1,
  approve,
  reject,
}

export enum SocietyStatuses {
  submitted,
  accepted,
  fullDispute,
  duplicateClaim,
}

export enum SocietyTypes {
  mechanical = 1,
  performing,
  universal,
}

export enum SocietyStatusesText {
  'Submitted',
  'Accepted',
  'Full dispute',
  'Duplicate claim',
}

export const workFilters: {[key: string]: number[]} = {
  All: [],
  Approved: [WorkStatuses.accepted.id, WorkStatuses.registered.id, WorkStatuses.updating.id, WorkStatuses.registering.id],
  Pending: [WorkStatuses.pending.id, WorkStatuses.inReview.id, WorkStatuses.submitted.id],
  Rejected: [WorkStatuses.rejected.id],
}

export enum releaseStatuses {
  partiallyCompleted = 1,
  processing,
  sentToStores,
  requestedTakedown,
  removed,
  inactive,
  active,
  incomplete,
  approved,
  requiresRepair,
  awaitingExplicitContentCheck,
}

export const releaseStatusesValidForWorks: releaseStatuses[] = [
  releaseStatuses.active,
  releaseStatuses.sentToStores,
  releaseStatuses.approved,
]

export const releaseTypes: {[key: number]: string} = {
  1: 'Single',
  2: 'EP',
  3: 'Album',
}

export const getWorkStatusColor = (statusId: number) => {
  switch (statusId) {
    case WorkStatuses.accepted.id:
    case WorkStatuses.registered.id:
    case WorkStatuses.updating.id:
    case WorkStatuses.registering.id:
      return 'green'
    case WorkStatuses.pending.id:
    case WorkStatuses.inReview.id:
    case WorkStatuses.submitted.id:
      return 'blue'
    case WorkStatuses.rejected.id:
    case WorkStatuses.terminated.id:
      return 'red'
    default:
      return 'blue'
  }
}

export const getWorkStatusName = (statusId: number): string => (
  Object.values(WorkStatuses).find(status => status.id === statusId)?.name || ''
)

export const getWriterStatusColor = (status: number) => {
  switch (status) {
    case WriterStatuses.approve:
      return 'green'
    case WriterStatuses.requested:
      return 'blue'
    case WriterStatuses.reject:
      return 'red'
    default:
      return 'blue'
  }
}

export const getSocietyStatusColor = (status: number | null) => {
  switch (status) {
    case SocietyStatuses.accepted:
      return 'green'
    case SocietyStatuses.fullDispute:
      return 'red'
    case SocietyStatuses.duplicateClaim:
      return 'red'
    case SocietyStatuses.submitted:
      return 'blue'
    default:
      return ''
  }
}

export enum releaseArtistTypes {
  primary = 1,
  featured,
  performer,
  remixer,
}

export const emptyAlternativeTitle: AlternativeTitle = {
  name: '',
}

export const emptySample: WorkSample = {
  title: '',
  writers_names: '',
  share: null,
}

export const emptyWriter: Writer = {
  name: '',
  email: '',
  role: null,
  share: null,
}

export const maxWorkWritersCount = 20
export const maxWorkSamplesCount = 10
export const maxWorkTitlesCount = 30

export const singleArrangerError = 'Claiming as an ‘Arranger’ indicates that you have arranged an existing musical work. With the exception of public domain works, arrangements of existing musical works need to be approved by the original copyright owner prior to registration.'
export const timeToAcceptShare = 7 * 24 * 60 * 60 * 1000 // 7 days in milliseconds

export enum SubscriptionTypes {
  revenuecat = 'revenuecat',
  rls = 'rls',
  manual = 'manual',
  stripe = 'stripe',
}
